module.exports = __webpack_public_path__ + "img/graph-point.21aaeb19.svg";